// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3BCbD","accent":"Logo_accent__1s7vk"};